export interface ConfigFileFormValues {
  name: string;
  defaultSourceRoot: string;
  sourceLocation: string;
  sourceFilename: string;
  targetLocation: string;
  targetFilename: string;
  ownerGroup: string;
  ownerName: string;
  type: string;
  serviceDefinitionId: string;
}

export interface ConfigFileValidationErrors {
  name?: string;
  defaultSourceRoot?: string;
  sourceLocation?: string;
  sourceFilename?: string;
  targetLocation?: string;
  targetFilename?: string;
  ownerGroup?: string;
  ownerName?: string;
  type?: string;
}

const MAX_FIELD_LENGTH = 255;

export function validateConfigFileForm(values: ConfigFileFormValues): ConfigFileValidationErrors {
  const errors: ConfigFileValidationErrors = {};

  // Name: required, non-whitespace-only
  if (!values.name.trim()) {
    errors.name = 'Name is required';
  } else if (values.name.length > MAX_FIELD_LENGTH) {
    errors.name = `Must not exceed ${MAX_FIELD_LENGTH} characters`;
  }

  // Length validation for all text fields
  const lengthFields: (keyof ConfigFileFormValues)[] = [
    'defaultSourceRoot', 'sourceLocation', 'sourceFilename',
    'targetLocation', 'targetFilename', 'ownerGroup', 'ownerName', 'type',
  ];

  for (const field of lengthFields) {
    if (values[field].length > MAX_FIELD_LENGTH) {
      (errors as Record<string, string>)[field] = `Must not exceed ${MAX_FIELD_LENGTH} characters`;
    }
  }

  return errors;
}

export function isFormValid(errors: ConfigFileValidationErrors): boolean {
  return Object.keys(errors).length === 0;
}
